<template>
    <div id="desktop-wrapper" ref="wrapper">
        <div class="header-desktop">
            <div class="navbar-desktop">
                <div class="nav-inner">
                    <div class="ion-float-start">
                        <ul class="ion-no-margin">
                            <router-link to="/">
                                <li class="header-links">
                                    <img class="logo" src="@/assets/logo-full.png" />
                                </li>
                            </router-link>
                        </ul>
                    </div>
                    <div>
                        <ul v-if="user">
                            <router-link to="/search">
                                <li class="header-links">{{ $t('master.search') }}</li>
                            </router-link>
                            <router-link v-if="!user.has_access" to="/plans">
                                <li class="header-links">{{ $t('master.membershipUpgrade') }}</li>
                            </router-link>
                            <router-link to="/messages">
                                <li class="header-links">{{ $t('master.chat') }}</li>
                            </router-link>
                            <router-link to="/notifications">
                                <li class="header-links">{{ $t('master.notifications') }}</li>
                            </router-link>
                            <router-link to="/likers-list">
                                <li class="header-links">{{ $t('master.listOfLikes') }}</li>
                            </router-link>
                            <router-link to="/profile-viewers">
                                <li class="header-links">{{ $t('master.profileViewers') }}</li>
                            </router-link>
                            <router-link to="/profiles-viewed">
                                <li class="header-links">{{ $t('master.profilesViewed') }}</li>
                            </router-link>
                        </ul>
                        <ul v-else>
                            <router-link to="/">
                                <li class="header-links">{{ $t('master.home') }}</li>
                            </router-link>
                            <router-link to="/search">
                                <li class="header-links">{{ $t('master.search') }}</li>
                            </router-link>
                            <router-link to="/terms">
                                <li class="header-links">{{ $t('master.terms') }}</li>
                            </router-link>
                            <router-link to>
                                <li class="header-links" @click="toggleLanguage">{{ $t('master.oppositeLanguage') }}</li>
                            </router-link>
                        </ul>
                    </div>
                    <div v-if="!user" class="ion-float-end">
                        <ul>
                            <router-link to="/">
                                <li class="header-links">{{ $t('master.login') }}</li>
                            </router-link>
                            <router-link to="/register/step-1">
                                <li class="header-links">{{ $t('master.signup') }}</li>
                            </router-link>
                        </ul>
                    </div>
                    <div v-else class="ion-float-end">
                        <router-link to="/user/me">
                            <ion-avatar class="profile-pic-top ion-float-start">
                                <img
                                    :src="
                                        user.images[0]
                                            ? `${constants.assetsUri}/${user.images[0].path}`
                                            : require('../assets/imgupload-square.png')
                                    "
                                />
                            </ion-avatar>
                            <span class="ion-float-start white user-name-top">{{ user.name }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-if="$route.path !== '/'" class="page-header ion-padding-vertical">
                <ion-text color="secondary">
                    <h1>{{ pageTitle($route.path) }}</h1>
                </ion-text>
                <img src="@/assets/title-icon.png" />
            </div>
        </div>
        <div :class="$route.path == '/' ? 'home-page-wrapper' : 'main-page-wrapper'">
            <router-view />
        </div>
        <div class="footer-desktop">
            <div class="outer">
                <ad-leaderboard class="ion-margin-top ion-margin-bottom" />
            </div>
            <div class="upper">
                <ion-grid class="upper-inner">
                    <ion-row>
                        <ion-col class="ion-text-start" size="4">
                            <div class="ion-padding-horizontal">
                                <h3>{{ $t('home.aboutUs') }}</h3>
                                <p>
                                    {{ $t('home.aboutUsText') }}
                                </p>
                                <p>
                                    <a href="https://www.facebook.com/SharekOmry-102569334710623/" target="_blank"
                                        ><img class="share-icons ion-margin-end" src="@/assets/icon-images/share-fb.png"
                                    /></a>
                                    <a href="https://twitter.com/OmrySharek" target="_blank"
                                        ><img class="share-icons ion-margin-end" src="@/assets/icon-images/share-twitter.png"
                                    /></a>
                                    <a href="https://www.instagram.com/sharek_omry/?hl=en" target="_blank"
                                        ><img class="share-icons ion-margin-end" src="@/assets/icon-images/share-insta.png"
                                    /></a>
                                </p>
                            </div>
                        </ion-col>
                        <ion-col class="ion-text-start" size="4">
                            <h3>{{ $t('home.contactUs') }}</h3>
                            <ion-button
                                @click="$router.push('/contact')"
                                shape="round"
                                class="ion-float-start ion-no-margin ion-padding-vertical"
                                color="primary"
                                strong
                            >
                                {{ $t('home.contactUsButton') }}
                            </ion-button>
                        </ion-col>
                        <ion-col class="ion-text-start" size="4">
                            <h3>{{ $t('privateProfile.yourProfile') }}</h3>
                            <div v-if="!user">
                                <router-link to="/">
                                    <ion-button
                                        shape="round"
                                        class="ion-no-margin ion-padding-vertical"
                                        color="primary"
                                        @click="scrollToLogin"
                                        strong
                                    >
                                        {{ $t('master.login') }}
                                    </ion-button>
                                </router-link>
                                <router-link to="/register/step-1">
                                    <ion-button
                                        shape="round"
                                        color="primary"
                                        class="ion-no-margin ion-margin-start ion-padding-vertical"
                                        strong
                                    >
                                        {{ $t('master.signup') }}
                                    </ion-button>
                                </router-link>
                            </div>
                            <div v-else>
                                <div class="footer-user-section">
                                    <router-link to="/user/me">
                                        <ion-avatar class="profile-pic-bottom ion-float-start">
                                            <img
                                                :src="
                                                    user.images[0]
                                                        ? `${constants.assetsUri}/${user.images[0].path}`
                                                        : require('../assets/imgupload-square.png')
                                                "
                                            />
                                        </ion-avatar>
                                        <span class="ion-float-start white user-name-bottom">{{ user.name }}</span>
                                    </router-link>
                                </div>

                                <div>
                                    <ion-button class="footer-logout" shape="round" color="primary" @click="handleLogout" strong>
                                        {{ $t('master.logout') }}
                                    </ion-button>
                                </div>
                            </div>
                        </ion-col>
                        <ion-col class="ion-padding" size="12">
                            <ul class="more-links ion-no-padding">
                                <router-link to="/">
                                    <li class="footer-links" v-if="$route.path !== '/'" @click="$router.push('/home')">
                                        {{ $t('master.home') }}
                                    </li>
                                </router-link>
                                <router-link to="/search">
                                    <li class="footer-links" v-if="$route.path !== '/search'" @click="$router.push('/search')">
                                        {{ $t('master.search') }}
                                    </li>
                                </router-link>
                                <router-link to="/terms">
                                    <li class="footer-links" v-if="$route.path !== '/terms'" @click="$router.push('/terms')">
                                        {{ $t('master.terms') }}
                                    </li>
                                </router-link>
                                <router-link to="/privacy-policy">
                                    <li
                                        class="footer-links"
                                        v-if="$route.path !== '/privacy-policy'"
                                        @click="$router.push('/privacy-policy')"
                                    >
                                        {{ $t('privacyPolicy.header') }}
                                    </li>
                                </router-link>
                                <router-link to>
                                    <li class="footer-links" @click="toggleLanguage">{{ $t('master.oppositeLanguage') }}</li>
                                </router-link>
                            </ul>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <div class="lower">
                <div class="lower-inner ion-padding">{{ $t('master.allRightsReserved') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import MainPage from './MainPage'
import { mapGetters } from 'vuex'
import { constants } from '../constants'
import AxiosController from '@/controllers/AxiosController'
import PageHeader from '@/components/PageHeader'
import AdLeaderboard from '@/components/AdLeaderboard'

export default {
    name: 'MainPage',
    components: { MainPage, PageHeader, AdLeaderboard },
    name: 'AppFooter',
    computed: mapGetters(['user']),
    data() {
        return {
            constants
        }
    },
    methods: {
        toggleLanguage: function() {
            this.$i18n.locale = this.$i18n.locale == 'en' ? 'ar' : 'en'
            this.$store.dispatch('setLanguage', this.$i18n.locale)
            if (this.user) {
                AxiosController.post('update-lang', { lang: this.$i18n.locale })
            } else {
                localStorage.setItem('locale', this.$i18n.locale)
            }
        },
        handleLogout: function() {
            this.$store.dispatch('logout').then(() => this.$router.push('/'))
        },
        scrollToLogin() {
            if (this.$route.path === '/') {
                this.$refs.wrapper.scrollIntoView(1)
            } else {
                this.$router.push('/')
                this.$refs.wrapper.scrollIntoView(1)
            }
        },
        pageTitle: function(link) {
            switch (link) {
                case '/search':
                    return this.$t('master.search')
                case '/register/step-1':
                case '/register/step-2':
                case '/register/step-3':
                    return this.$t('master.signup')
                case '/user/me':
                    return this.$t('privateProfile.title')
                case '/messages':
                    return this.$t('master.chat')
                case '/change-password':
                    return this.$t('master.changePassword')
                case '/plans':
                case '/payments':
                    return this.$t('master.membershipUpgrade')
                case '/edit-profile':
                    return this.$t('privateProfile.editProfile')
                case '/likers-list':
                    return this.$t('master.peopleWhoLikeYou')
                case '/profiles-viewed':
                    return this.$t('master.profilesViewed')
                case '/profile-viewers':
                    return this.$t('master.profileViewers')
                case '/blocked-users':
                    return this.$t('privateProfile.blockedUsers')
                case '/edit-profile-pictures':
                    return this.$t('privateProfile.profilePictures')
                case '/notifications':
                    return this.$t('notifications.title')
                case '/contact':
                    return this.$t('master.support')
                case '/terms':
                    return this.$t('master.terms')
                case '/privacy-policy':
                    return this.$t('privacyPolicy.header')
                case '/forgot-password':
                    return this.$t('master.resetPassword')
                default:
                    return this.$t('master.findMatch')
            }
        }
    }
}
</script>

<style lang="scss">
.ion-page {
    overflow: auto !important;
}
</style>

<style lang="scss" scoped>
.logo {
    width: 150px;
    padding-top: 5px;
}

.main-page-wrapper {
    width: 70%;
    margin: 0 auto;
    display: inline-block;
    background-color: #f5f5f5;
    padding: 15px;
    position: relative;
    top: -5vh;
    min-height: 400px;
}

.home-page-wrapper {
    width: 100%;
    display: inline-block;
    background-color: #f5f5f5;
    position: relative;
}
.footer-desktop {
    width: 100%;
    .upper {
        background-color: #093341;
        color: #ffffff;
    }
    .upper-inner {
        max-width: 1200px;
        margin: 0 auto;
    }
    .lower {
        background-color: #072933;
        color: #62909f;
        font-size: 12px;
    }
    .lower-inner {
        max-width: 1200px;
        margin: 0 auto;
    }
}

.footer-desktop p {
    font-size: 14px;
    width: 80%;
}
.more-links li {
    display: inline-block;
    padding: 0 12px;
}
.header-desktop {
    width: 100%;
    background-color: #a6b5a0;
    background: linear-gradient(#92f0ae80, #70fa9a80), url('~@/assets/chat-bg.jpg');
    background-size: cover;
    ul {
        list-style: none;
        padding: 5px 10px;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    div {
        display: inline-block;
    }
    .page-header {
        padding: 70px 0 100px 0;
    }
}
.navbar-desktop {
    background-color: #093341;
    color: #ffffff;
    width: 100%;
}

.profile-pic-bottom {
    width: 50px;
    height: 50px;
}

.profile-pic-top {
    width: 35px;
    height: 35px;

    img {
        position: relative;
        top: 7px;
    }
}

.user-name-top {
    position: relative;
    top: 13px;
    margin: 0 10px;
    font-weight: 700;
}

.user-name-bottom {
    font-size: 20px;
    font-weight: 700;
    margin: 10px;
}

.header-links,
.footer-links {
    color: #ffffff;
}
.footer-user-section {
    display: inline-block;
    width: 100%;
}
.nav-inner {
    margin: 0 auto;
    width: 1200px;
    font-size: 14px;
}
.share-icons {
    background-color: white;
    width: 50px;
}
</style>
